<template>
    <div v-if="!hide" class="form-network form-network-tiktok">
       <details open>
           <summary>Confidentialité <i class="fa-solid fa-caret-down"></i></summary>
           <div class="content-detail">
                <SelectComponent :valueSelect="formDataTiktok.visibility" :changeValueSelect="changeVisibilityPost" :data="{all:'Disponible aux public', friends:'Disponible seulement pour mes amies',me:'Disponible seulement pour moi'}"  :positionAuto="false" :positionX="'left'"></SelectComponent>
                <div class="type-switch">
                        Désactiver les commentaires
                    <ComponentSwitch :value="formDataTiktok.commentDisable" :onChange="(v)=> formDataTiktok.commentDisable = v" :id="'switch-settings-advanced-tiktok-1'"></ComponentSwitch>
                </div>
                <div class="type-switch">
                        Autoriser l'utilisation de cette vidéo en mode duo
                    <ComponentSwitch :value="formDataTiktok.useVideoForDuo" :onChange="(v)=>{formDataTiktok.useVideoForDuo = v}" :id="'switch-settings-advanced-tiktok-2'"></ComponentSwitch>
                </div>
                <div class="type-switch">
                        Autoriser l'utilisation de cette vidéo pour d'autre video
                    <ComponentSwitch :value="formDataTiktok.useVideoForOtherVideo" :onChange="(v)=>{formDataTiktok.useVideoForOtherVideo = v}" :id="'switch-settings-advanced-tiktok-3'"></ComponentSwitch>
                </div>
              
             
           </div>      
       </details>
   </div>
</template>

<script>
    import { EventBus } from '@/event-bus';
    import store from './../../../../store/index.js';
    import ComponentSwitch from '../../utils/switch.vue'
    import SelectComponent from '../../utils/select.vue'
    import SnippetNetwork from './../SnippetNetwork.vue'
    import minxinBot from '../../../mixins/Bots.vue'
    import minxinPost from '../../../mixins/Posts.vue'
    export default {

       components: {
           ComponentSwitch,
           SnippetNetwork,
           SelectComponent
       },
       mixins: [minxinBot,minxinPost],

       props: {
           hide : {
               type: Boolean,
               default: false
           },
           formData: {
               type: Object,
               default: () => ({})
           },

           formDataTiktok: {
               type: Object,
               default: () => ({})
           },
       },

       data() {
           return {
               inputModel:{

               },

               lastModeSelected : undefined
           }
       },

       
       mounted() {
            if (this.formData.formDataNetwork.tiktok) this.formDataTiktok = this.formData.formDataNetwork.tiktok 
       },

       methods: {
           addMode(mode) {
               this.lastModeSelected = mode
               EventBus.$emit("postCreatorAddMode", mode);
           },
           changeVisibilityPost(state) {
                this.formDataTiktok.visibility = state
                this.$emit('setFormDataNetwork', 'tiktok', this.formDataTiktok)
            },

       },

       computed: {
           allPages() {
               return this.$store.getters['selectPage/selectPageAllPages'];
           },
           pagesSelected() {
               return this.$store.getters['selectPage/selectPagePageSelected'];
           },
       },

       watch: {

            ['formData.formDataNetwork.tiktok']() {
                if (this.formData.formDataNetwork.tiktok) this.formDataTiktok = this.formData.formDataNetwork.tiktok
            },

       },


       beforeDestroy () {
       }
       
   }
</script>